module.exports = __webpack_public_path__ + "img/buttonFilter.df471fe0.svg";